import { render, staticRenderFns } from "./ImportedArticle.vue?vue&type=template&id=d4f0739c&scoped=true&"
import script from "./ImportedArticle.vue?vue&type=script&lang=js&"
export * from "./ImportedArticle.vue?vue&type=script&lang=js&"
import style0 from "./ImportedArticle.vue?vue&type=style&index=0&id=d4f0739c&prod&lang=scss&scoped=true&"
import style1 from "./ImportedArticle.vue?vue&type=style&index=1&id=d4f0739c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f0739c",
  null
  
)

export default component.exports